export const API_EXTERNAL_ENDPOINT = 'provinces'

export const API_INTERNAL_ENDPOINT = 'rurality/v3/provinces/detail'
